<!-- 机模配 -->
<template>
  <div style="display: inline;">
    <el-form :inline="true" ref="form" size="mini" :label-width="formLabelWidth">
      <el-form-item>
        <yi_number_input :start.sync="editObj.tonnageMin" :end.sync="editObj.tonnageMax" :type="'numberrange'">
        </yi_number_input>
      </el-form-item>
      <el-button :loading="store.state.global_loading" size="mini"
                 @click="save(editObj)" type="primary">
        {{ $t('baocun') }}
      </el-button>
    </el-form>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_base_mould_mould_equipment_tonnage',
  data() {
    return {
      editObj: this.$attrs.mouldEquipment,
      min: this.$attrs.mouldEquipment.tonnageMin,
      max: this.$attrs.mouldEquipment.tonnageMax,
    };
  },
  created() {

  },
  methods: {

    //保存吨位值
    save() {
      if (!this.editObj.tonnageMin || !this.editObj.tonnageMax) {
        this.utils.errorMessage(this.$t('shipeidunweibunengweikong'))
        return
      }
      this.http.post('/web/basic/mould/tonnage/update', this.editObj).then(res => {
        this.utils.successMessage(this.$t(res.msg));
        this.refresh();
      }).catch(error => {
        this.utils.errorMessage(this.$t(error));
        this.editObj.tonnageMin = this.min;
        this.editObj.tonnageMax = this.max;
      });
    },
    //刷新列表页面
    refresh() {
      this.utils.event_hub.$emit('EQUIPMENT_MOULD_REFRESH');
    }
  }
};
</script>


<style>
</style>
